/**
 * This is the specification for the temp dashboard in localStorage
 */
export default {
  dashboards: {},
};
